/* @jsxImportSource @emotion/react */

// Relative import (not a workspace dependency): pulling @slite/editor-ui into
// the website would drag the whole editor dependency tree into its Docker
// image for one stylesheet. The Dockerfile copies this directory explicitly.
import '../../../../packages/editor-ui/src/plugins/HybridTableUI/hybrid-table.css'
import '../../../../packages/editor-ui/src/plugins/LineBreakUI/style.css'

// The editor zeroes the top margin of the doc's first block so it sits right
// under the title; the HTML export keeps per-block margins, so replicate the
// suppression along the first-child chain (block wrappers are plain divs).
const FIRST_BLOCK_CHAIN = [1, 2, 3]
  .map(
    (depth) => `& .editable-container ${'> :first-child '.repeat(depth).trim()}`
  )
  .join(', ')

// Inject a note's HTML export (only the editor CSS is stripped server-side, the
// inline emotion styles are kept) into the page; the rest of the styling comes
// from `@slite/style` plus the editor's own table stylesheet. The export's
// attribute casing is normalized by the browser, so hydration warnings on this
// subtree are expected and suppressed.
export function HelpHtml({ html }: { html: string }) {
  return (
    <div
      data-test-id="helpArticleContent"
      className="help-article-content width-full"
      css={{ [FIRST_BLOCK_CHAIN]: { marginTop: 0 } }}
      suppressHydrationWarning
      // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted Slite HTML export from our own public API
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
